export enum InvestigationSessionPanelTab {
	Attendance = "attendance",
	Questions = "questions",
	Attachments = "attachments",
	Minutes = "minutes",
}
